import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PreChatConstants } from "../pre-chat-constants";

export function emailValidator(): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        if (!control) {
            throw new Error("FormControl is undefined/null");
        }

        const isValid = control.value === "" || (((control.value as string) || "").trim().length >= 5 && 
            (new RegExp(PreChatConstants.EMAIL_REGEXP, "i").test(control.value) || new RegExp(PreChatConstants.QUOTED_EMAIL_REGEXP, "i").test(control.value)));
        console.log("isValid ", isValid, "control name ", control.value);
        return isValid ? null : { incorrectMailFormat: true };
    };
}
